import LogoWatermark from "assets/images/logo-watermark.png";

const getImageHandlerUrl = (path) => `${import.meta.env.VITE_IMAGE_HANDLER_HOST}/${path}`;
const getContentfulImageHandlerUrl = (path) => `${import.meta.env.VITE_CONTENTFUL_IMAGE_HANDLER_HOST}/${path}`;

export const BUCKET_LIST = {
  packs: import.meta.env.VITE_WEBPACK_ASSETS_AWS_BUCKET,
  image_assets: import.meta.env.VITE_UGC_ASSETS_AWS_BUCKET,
  contentful: import.meta.env.VITE_CONTENTFUL_UGC_ASSETS_AWS_BUCKET,
  pills: import.meta.env.VITE_UGC_ASSETS_AWS_BUCKET,
  heads: import.meta.env.VITE_UGC_ASSETS_AWS_BUCKET,
  ugc: import.meta.env.VITE_AWS_UGC_BUCKET,
  static: import.meta.env.VITE_STORYBOOK_AWS_BUCKET,
};

export const key = (src) => {
  if (!src) return "";

  let path = src;
  if (src.includes("localhost")) {
    path = src.split("localhost:3000/").pop();
  } else if (src.includes("assets.jibjab.dev")) {
    path = src.split("assets.jibjab.dev/").pop();
  } else if (src.includes("jibjab.com/")) {
    path = src.split("jibjab.com/").pop();
  }

  return path.startsWith("/") ? path.substring(1) : path;
};

export const bucket = (src) => {
  const index = key(src).split("/");

  if (!index[0]) return null;

  return BUCKET_LIST[index[0]];
};

export const getImageUrl = (src, { newWidth, newHeight, watermark = false }) => {
  const bucketToUse = bucket(src);
  const keyToUse = key(src);
  if (!keyToUse || !bucketToUse) return src;

  const data = {
    bucket: bucketToUse,
    key: keyToUse,
    edits: {
      resize: {
        fit: "cover",
        withoutEnlargement: true,
      },
      filters: [],
    },
  };

  if (newWidth) {
    data.edits.resize.width = newWidth;
  }

  if (newHeight) {
    data.edits.resize.height = newHeight;
  }

  if (watermark) {
    data.edits.overlayWith = {
      bucket: import.meta.env.VITE_WEBPACK_ASSETS_AWS_BUCKET,
      key: key(LogoWatermark),
      alpha: 1,
      wRatio: 10,
      hRatio: 6,
      options: {
        top: "-2p",
        left: "-2p",
      },
    };
  }

  const isContentful = data.key.split("/")[0] === "contentful";
  const newPath = window.btoa(unescape(encodeURIComponent(JSON.stringify(data))));

  return isContentful ? getContentfulImageHandlerUrl(newPath) : getImageHandlerUrl(newPath);
};
